import { getAnimeShows } from "./grid.js";
import "./nav.js";

